var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1805 0.695393C10.3188 -0.564031 9.1643 0.170633 8.69477 0.695393L0.0776641 15.6925C-0.320049 17.0845 0.906233 17.6534 1.56909 17.7639H18.6376C19.8307 17.6976 20.3776 16.521 19.7147 15.4439L11.1805 0.695393ZM11.2632 13.9526C11.2632 14.7305 10.6326 15.3611 9.85466 15.3611C9.07673 15.3611 8.4461 14.7305 8.4461 13.9526C8.4461 13.1746 9.07673 12.544 9.85466 12.544C10.6326 12.544 11.2632 13.1746 11.2632 13.9526ZM9.02596 10.4724L8.52882 5.91526C8.47358 5.72193 8.49568 5.30212 9.02596 5.16955H11.0145C11.125 5.19717 11.3459 5.38498 11.3459 5.91526L10.8488 10.4724H9.02596Z",
    fill: "#52BD70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.8b81f37d3d13552a185d3d55cc1a4401.svg";
export { ForwardRef as ReactComponent };